/** @file islandImage: one island cut out of its sheet: its box, only its own pixels, the rest transparent. */
import { createImage } from '../image/createImage';
import type { Image } from '../types/image';
import type { Island, IslandMap } from './islandTypes';

/** A `w` x `h` image of `island`'s box where pixels labelled with its id are copied and every other pixel is clear. */
export function islandImage(sheet: Image, map: IslandMap, island: Island): Image {
  const out = createImage(island.w, island.h);
  for (let y = 0; y < island.h; y++) {
    for (let x = 0; x < island.w; x++) {
      const p = (island.y + y) * map.width + island.x + x;
      if (map.labels[p] !== island.id) continue;
      out.data.set(sheet.data.subarray(p * 4, p * 4 + 4), (y * island.w + x) * 4);
    }
  }
  return out;
}
